import styled from "styled-components";
import { ParcelCol, ParcelRow } from "styles/parcelsStyles";

interface WrapperProps {
  disabled: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  &:not(:first-child) > div {
    border-top: none;
  }

  ${({ disabled }) =>
    disabled &&
    `
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const TableCol = styled(ParcelCol)`
  text-align: left;
  line-height: 20px;

  .tooltip-content-checkbox {
    min-width: 18px;
  }

  &:nth-child(4) > div {
    margin-left: 15px;
  }

  ${(props) => props.theme.lg`
    white-space: normal;
  `}

  ${(props) => props.theme.xs`
    &:nth-child(4) > div {
      margin-left: 10px;
    }
  `}
  
  ${(props) => props.theme.xs`
    margin-bottom: 5px;
  `}
`;

export const TableRow = styled(ParcelRow)`
  ${({ theme }) => theme.range("padding", "0px", "6px")};

  ${(props) => props.theme.xs`
    padding: 5px 0 0;
  `};

  & > ${TableCol} {
    &:first-child {
      justify-content: space-between;
    }

    &:last-child {
      flex-wrap: wrap;
      margin-bottom: 0;
    }
  }
`;

export const MainCol = styled(ParcelCol)`
  min-height: 61px !important;
`;

interface AmountIconProps {
  $isPositive: boolean;
}

export const AmountIcon = styled.div<AmountIconProps>`
  font-weight: 600;
  margin-right: 4px;
  ${({ $isPositive }) => `font-size: ${$isPositive ? "18px" : "24px"};`}
  ${({ $isPositive }) => `color: ${$isPositive ? "green" : "red"};`}
`;
